import { useQuery } from "@tanstack/react-query";

import { type GetPromptsOutput, listPrompts } from "@api/rest/types-and-hooks";

/** Every prompt, fetched page by page. The list_prompts endpoint caps
 * page_size at 100, so this loops until a short page. One shared query
 * key, so every caller on the page reads the same cache. A failed page
 * fails the query, so callers never mistake a partial list for all of
 * them. */
export function useAllPrompts() {
  return useQuery({
    queryKey: ["all-prompts"],
    queryFn: async () => {
      const results: GetPromptsOutput[] = [];
      let page = 1;
      while (true) {
        const response = await listPrompts({ page, page_size: 100 });
        if (response.status !== 200) throw new Error(`Failed to load prompts (${response.status})`);
        results.push(...response.data.results);
        if (response.data.results.length < 100) break;
        page++;
      }
      return results;
    },
  });
}
